export default __webpack_public_path__ + "static/media/atlanta.c1833023.png";